import { useEventListener } from "@business-finland/wif-ui-lib";
import {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
  useTransition,
  useCallback,
} from "react";

import { getViewportByWindowWidth } from "../util/viewport";

const initialViewport: Wif.ViewportState = { viewport: "xl", isMobile: false };
const ViewportContext = createContext<Wif.ViewportState>(initialViewport);

export function ViewportContextProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const [, startTransition] = useTransition();
  const [viewport, setViewport] = useState<Wif.ViewportState>(initialViewport);

  const checkIsMobile = useCallback((viewport: Wif.Viewport) => {
    return viewport === "xs" || viewport === "sm" || viewport === undefined;
  }, []);

  const updateViewport = useCallback(() => {
    const viewport = getViewportByWindowWidth();
    setViewport((prev) => ({
      ...prev,
      viewport,
      isMobile: checkIsMobile(viewport),
    }));
  }, [checkIsMobile]);

  useEffect(() => startTransition(updateViewport), [updateViewport]);

  useEventListener("resize", () => startTransition(updateViewport));

  return (
    <ViewportContext.Provider value={viewport}>
      {children}
    </ViewportContext.Provider>
  );
}

export default function useViewport() {
  return useContext(ViewportContext);
}
